export const ENV = {
  API_URL: process.env.REACT_APP_API_URL,
  ENVIRONMENT: process.env.REACT_APP_ENV,
  Image_Base_Url: process.env.REACT_APP_IMAGE_BASE_URL
};
